"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = populateCart;
exports.populateNormalCart = populateNormalCart;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ssisGet = require("../components/ssisGet");

var _ssisGet2 = _interopRequireDefault(_ssisGet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

populateCart();

if ((0, _jquery2.default)(".cart-item--static").length) {
  cartNormalProgressStatus();

  (0, _jquery2.default)(".cart-item__toggle-prescription-table").on("click", function (e) {
    e.preventDefault();
    var id = (0, _jquery2.default)(this).attr("href");
    var elem = (0, _jquery2.default)(id);

    (0, _jquery2.default)(this).find(".toggle-icon").toggleClass("open");
    elem.find(".cart-item__prescription-table").slideToggle();
  });

  // check product upsell
  appendUpsell();

  // toggle mobile bag
  mobileToggleBag();

  // discount info
  // CheckInitSetup(1000, 5000);
  checkDiscountEvent(1000, 5000);
}

(0, _jquery2.default)(window).on("load scroll resize", function () {
  // cartDrawerItemsHeight();
  cartDrawerPosition();
});

var openDrawer = false;
(0, _jquery2.default)(".js-cart-btn").on("mouseover", function (e) {
  // e.preventDefault();
  // cartDrawerItemsHeight();
  (0, _jquery2.default)(".cart-drawer").addClass("expanded");
  cartDrawerPosition();

  (0, _jquery2.default)(".cart-drawer").on("mouseover", function () {
    (0, _jquery2.default)("html, body").addClass("no-scroll");
    openDrawer = true;
  }).on("mouseleave", function () {
    (0, _jquery2.default)(".cart-drawer").removeClass("expanded");
    (0, _jquery2.default)("html, body").removeClass("no-scroll");
    openDrawer = false;
  });
}).on("mouseleave", function () {
  setTimeout(function () {
    if (!openDrawer && (0, _jquery2.default)(".cart-drawer").hasClass("expanded")) {
      (0, _jquery2.default)("html, body").removeClass("no-scroll");
      (0, _jquery2.default)(".cart-drawer").removeClass("expanded");
    }
  }, 500);
});

(0, _jquery2.default)(document).on("click", ".js-cart-remove", function (e) {
  e.preventDefault();
  var url = (0, _jquery2.default)(this).attr("href");
  var lensId = (0, _jquery2.default)(this).data("lensKey");
  var thsParent = (0, _jquery2.default)(this).parent().hasClass("js-remover-parent");

  function removeFrame() {
    _jquery2.default.ajax({
      url: url,
      type: "POST",
      beforeSend: function beforeSend() {
        (0, _jquery2.default)(".cart-drawer, .section-cart").addClass("loading-icon");
      }
    }).done(function () {
      thsParent ? populateNormalCart() : populateCart();
    }).fail(function () {
      (0, _jquery2.default)(".cart-drawer, .section-cart").removeClass("loading-icon");
      console.log("error cart remove");
    });
  }

  // Remove lens associated with frame being removed
  if (lensId !== "") {
    var lensUrl = "/cart/change.js?id=" + lensId + "&quantity=0";
    _jquery2.default.ajax({
      url: lensUrl,
      type: "POST"
    }).done(function () {
      removeFrame();
    }).fail(function (error) {
      console.log(error);
    });
  } else {
    removeFrame();
  }
});

function populateCart() {
  var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var loadingElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".cart-drawer";

  if (loading) {
    (0, _jquery2.default)(loadingElement).addClass("loading-icon");
  }

  _jquery2.default.ajax({
    url: "/cart",
    type: "GET"
  }).done(function (data) {
    var $cartContainer = (0, _jquery2.default)(".js-cart-drawer-container");
    var $cartBtn = (0, _jquery2.default)(".js-cart-btn");
    var $cartHTML = (0, _jquery2.default)(data).find(".js-cart-drawer-ajax").html();
    var cartCounterText = (0, _jquery2.default)(data).find(".item-counter").text();

    // inser html
    $cartContainer.html($cartHTML);
    $cartBtn.find(".btn-cart__counter").text(cartCounterText);

    (0, _jquery2.default)(loadingElement).removeClass("loading-icon");

    cartDrawerPosition();

    // set progress bar
    if ((0, _jquery2.default)(".cart-drawer .cart-widget__item").length) {
      (0, _jquery2.default)(".cart-progress").show();
      (0, _jquery2.default)(".cart-drawer").removeClass("cart-drawer__empty");
      cartProgressStatus();
    } else {
      (0, _jquery2.default)(".cart-drawer").addClass("cart-drawer__empty");
      (0, _jquery2.default)(".cart-progress").show();
    }

    var initializer = new _ssisGet2.default();
    initializer.init();
  }).fail(function () {
    (0, _jquery2.default)(loadingElement).removeClass("loading-icon");
    console.log("error populate cart");
  });
}

function populateNormalCart() {
  var loadingElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".js-cart-section";

  _jquery2.default.ajax({
    url: "/cart",
    type: "GET"
  }).done(function (data) {
    var $cartContainer = (0, _jquery2.default)(".js-cart-section ");
    var $cartContainerBody = (0, _jquery2.default)(".section__body");
    var $cartBtn = (0, _jquery2.default)(".js-cart-btn");
    var $cartHTMLSection = (0, _jquery2.default)(data).find(".js-cart-section").html();
    var $cartHTMLSectionBody = (0, _jquery2.default)(data).find(".section__body").html();
    var cartCounterText = (0, _jquery2.default)(data).find(".item-counter").text();

    if ((0, _jquery2.default)(data).find(".cart-item--static").length) {
      $cartContainerBody.html($cartHTMLSectionBody);
      cartNormalProgressStatus();
    } else {
      $cartContainer.html($cartHTMLSection);
    }

    $cartBtn.find(".btn-cart__counter").text(cartCounterText);

    (0, _jquery2.default)(loadingElement).removeClass("loading-icon");
    var initializer = new _ssisGet2.default();
    initializer.init();

    // check product upsell
    appendUpsell();

    // toggle mobile bag
    mobileToggleBag();

    // discount info
    // CheckInitSetup(500, 5000);
    checkDiscountEvent(500, 3000);
  }).fail(function () {
    alert("failed");
    (0, _jquery2.default)(loadingElement).removeClass("loading-icon");
    console.log("error populate normal cart");
  });
}

function appendUpsell() {
  if ((0, _jquery2.default)(".cart-product-upsell").length && (0, _jquery2.default)(window).width() < 992) {
    (0, _jquery2.default)(".cart-static").append((0, _jquery2.default)(".cart-product-upsell"));
    setTimeout(function () {
      (0, _jquery2.default)(".cart-product-upsell").fadeIn();
    }, 500);
  }
}

function mobileToggleBag() {
  if ((0, _jquery2.default)(window).width() < 992) {
    (0, _jquery2.default)(".section__head-left h1").on("click", function () {
      (0, _jquery2.default)(this).toggleClass("collapsed");
      (0, _jquery2.default)(".cart-static__items-wrapper").slideToggle();
    });
  }
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function CheckInitSetup(interval, timeout) {
  // handle discount event
  var timer = setInterval(calculateDiscount, interval);
  var good = false;

  function calculateDiscount() {
    console.log("Processing: Checking for dcode info...");
    if ((0, _jquery2.default)("#dcodeInfo").length) {
      console.log("Success: Dcode info found");
      clearInterval(timer);
      good = true;

      var elem = (0, _jquery2.default)(".cart-order-summary-total");
      var origTotal = (0, _jquery2.default)(".cart-static__row--total").data("value");
      var discountValue = (0, _jquery2.default)(".dcode-discount-value-cell .dcode-discount-value").text();
      var origTotalFormat = parseInt(origTotal.length > 3 ? origTotal.replace(",", "") : origTotal);
      var discounted = (0, _jquery2.default)(".dcodeTotalValue .dcode-total-value").text();
      var subtotal = +parseFloat(discounted).toFixed(2);
      var shipping = origTotalFormat > 1999 ? 0 : 150;
      var newTotal = +parseFloat(subtotal + shipping).toFixed(2);

      elem.text("P" + numberWithCommas(newTotal));

      // insert discount value
      if ((0, _jquery2.default)(".discount-value-placeholder").length) {
        (0, _jquery2.default)(".discount-value-placeholder").remove();
      }
      (0, _jquery2.default)("#dcodeInfo").append('<p class="discount-value-placeholder">-&nbsp;P' + numberWithCommas(discountValue) + "</p>");

      // remove discount
      (0, _jquery2.default)(".dcDiscountBox button").on("click", function () {
        elem.text("P" + numberWithCommas(origTotalFormat + shipping));
      });
    }
  }

  setTimeout(function () {
    if (!good) {
      console.log("Failed: There is no discount applied yet.");
      clearInterval(timer);
    }
  }, timeout);
}

function checkDiscountEvent(interval, timeout) {
  var timer = setInterval(handleDiscount, interval);
  var good = false;

  function handleDiscount() {
    console.log("Processing: Waiting for dcode element");
    if ((0, _jquery2.default)("#dcodeOuterWrapper").length) {
      console.log("Success: Dcode element is ready");
      CheckInitSetup(500, 10000);
      clearInterval(timer);
      good = true;

      (0, _jquery2.default)("#dcodeSubmit").on("click", function () {
        if ((0, _jquery2.default)("#dcodeInput").val() !== "") {
          console.log("applying code in progress...");
          CheckInitSetup(1000, 10000);
          setTimeout(function () {
            if (!good) {
              clearInterval(timer);
            }
          }, 5000);
        }
      });

      (0, _jquery2.default)("#dcodeInput").on("keydown", function (e) {
        if (e.key == "Enter") {
          console.log("applying code in progress...");
          CheckInitSetup(1000, 10000);
          setTimeout(function () {
            if (!good) {
              clearInterval(timer);
            }
          }, 5000);
        }
      });
    }
  }

  setTimeout(function () {
    if (!good) {
      console.log("Failed: Dcode not found");
      clearInterval(timer);
    }
  }, timeout);
}

function cartProgressStatus() {
  // set progress bar
  var totalValue = (0, _jquery2.default)(".cart-widget__total-value.total").data("value");
  var cartTotal = totalValue.length > 3 ? totalValue.replace(/[^\d]/g, "") : totalValue;
  var cartProgressPerc = cartTotal / 1999 * 100;
  (0, _jquery2.default)(".cart-progress-bar__filled").css({
    width: cartProgressPerc + "%"
  });

  // check if user reached the limit
  if (cartTotal >= 1999) {
    (0, _jquery2.default)(".cart-progress-status").addClass("complete").removeClass("incomplete").text("Congrats! You get free shipping ✨");
    (0, _jquery2.default)(".cart-widget .cart-widget__total.shipping .cart-widget__total-value").text("free");
  } else {
    (0, _jquery2.default)(".cart-progress-status").addClass("incomplete").removeClass("complete").text("Add P" + (1999 - cartTotal) + " more to get free shipping");
    (0, _jquery2.default)(".cart-widget .cart-widget__total.shipping .cart-widget__total-value").text("P150");
  }
}

function cartNormalProgressStatus() {
  // set progress bar
  var totalValue = (0, _jquery2.default)(".cart-static__row--total").data("value");
  var cartTotal = totalValue.length > 3 ? totalValue.replace(/[^\d]/g, "") : totalValue;
  var cartProgressPerc = cartTotal / 1999 * 100;
  (0, _jquery2.default)(".cart-progress-bar__filled").css({
    width: cartProgressPerc + "%"
  });

  // check if user reached the limit
  if (cartTotal >= 1999) {
    (0, _jquery2.default)(".cart-progress-status").addClass("complete").removeClass("incomplete").text("Congrats! You get free shipping ✨");
    (0, _jquery2.default)(".cart-static--shipping").text("free");
  } else {
    (0, _jquery2.default)(".cart-progress-status").addClass("incomplete").removeClass("complete").text("Add P" + (1999 - cartTotal) + " more to get free shipping");
    (0, _jquery2.default)(".cart-static--shipping").text("P150");
  }
}

function cartDrawerPosition() {
  var shellSpace = ((0, _jquery2.default)(window).width() - (0, _jquery2.default)(".header .shell").width()) / 2;
  (0, _jquery2.default)(".cart-drawer").css({ right: shellSpace });
  (0, _jquery2.default)("html").removeClass("no-scroll");
}